import { LOGIN, SIGNUP, GET_USER_DATA, LOGOUT } from '~/redux/reducers/session';
import { LOAD_COMBINED_DYNAMIC } from '~/redux/reducers/info';
import { actions as sessionActions } from '~/redux/reducers/session';
import isEmpty from 'lodash/isEmpty';

export default ({ dispatch }) => next => action => {
  const isGetNoti = [
    LOGIN.RESOLVED.toString(),
    SIGNUP.RESOLVED.toString(),
    GET_USER_DATA.RESOLVED.toString(),
    LOAD_COMBINED_DYNAMIC.RESOLVED.toString(),
    LOGOUT.RESOLVED.toString(),
  ].includes(action.type);

  const isRejected = [
    LOGIN.REJECTED.toString(),
    SIGNUP.REJECTED.toString(),
    GET_USER_DATA.REJECTED.toString(),
    LOAD_COMBINED_DYNAMIC.REJECTED.toString(),
  ].includes(action.type);

  if (!isGetNoti || !action.promise || isRejected) {
    return next(action);
  }

  const { userData, user } = action.data;
  if ((userData && userData.isLoggedIn) || !isEmpty(user)) {
    dispatch(sessionActions.getNotiCount());
    dispatch(sessionActions.getLatestMessages());
  }
  return next(action);
};
